import _ from 'underscore';
import ko from 'knockout';

export default class ViewModel {
  constructor({
    finalUrlSuffix,
    i18n,
    editMode,
    showPlaceholder = false,
  }) {
    this.editMode = ko.observable(editMode);

    this.maxLength = 1024;

    this.finalUrlSuffix = ko.observable(finalUrlSuffix);

    this.validate = (newFinalUrlSuffix) => {
      if (this.externalErrors) {
        this.externalErrors([]);
      }
      let errorList = [];
      const invalidFirstChars = ['#', '?', '&'];
      const firstChar = _.first(newFinalUrlSuffix);

      if (_.contains(invalidFirstChars, firstChar) || /\s|\r|\n/g.test(newFinalUrlSuffix)) {
        errorList = _.union(errorList, [i18n.getString('Error_Campaign_API_InvalidCharactersInValue')]);
      }

      // Parameters reserved for tracking template can not be used here.
      if (_.find(
        ['{lpurl}',
          '{lpurl+2}',
          '{lpurl+3}',
          '{unescapedlpurl}',
          '{ignore}',
          '{escapedlpurl}',
          '{escapedlpurl+2}',
          '{escapedlpurl+3}',
          '{ignore}',
        ],
        tag => newFinalUrlSuffix.indexOf(tag) === 0
      )) {
        errorList = _.union(errorList, [i18n.getString('Error_Campaign_API_InvalidTag')]);
      }

      return errorList;
    };

    this.errorMessages = ko.computed(() => {
      if (this.finalUrlSuffix()) {
        return this.validate(this.finalUrlSuffix());
      }
      return [];
    });

    this.externalErrors = ko.observableArray();

    this.showNone = ko.computed(() => !this.editMode() && !this.finalUrlSuffix());

    this.isValid = ko.computed(() => !this.errorMessages().length, this);

    this.placeholderText = showPlaceholder ? i18n.getString('UpgradedUrl_Placeholder_FinalUrlSuffix') : '';
  }
}
